module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditDetails) ? [_vm._v("\n        Edit industry details:\n      ")] : _vm._e(), _vm._v("\n      " + _vm._s(this.industry.details.name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    class: [{
      'not-allowed': (_vm.industry.details.companies && _vm.industry.details.companies.length) || _vm.industry.details.id === 1
    }],
    attrs: {
      "title": _vm.deleteMessage()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteIndustry()
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "dashboard active",
    attrs: {
      "to": {
        name: 'edit-industry',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Basic data")]), _vm._v(" "), (_vm.landing) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.landing
        }
      }
    }
  }, [_vm._v("Landing")]) : _vm._e(), _vm._v(" "), (!_vm.landing) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLanding()
      }
    }
  }, [_vm._v("Create landing")]) : _vm._e(), _vm._v(" "), (_vm.registrationLanding) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.registrationLanding,
          company: 'default'
        }
      }
    }
  }, [_vm._v("Registration landing")]) : _vm._e(), _vm._v(" "), (!_vm.registrationLanding) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRegistrationLanding()
      }
    }
  }, [_vm._v("Create registration landing")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-emails',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom emails")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-styling',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom email and website styling")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "industryDetails",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditDetails === false) ? [_vm._v("Industry details")] : [_vm._v("Edit industry details")]], 2), _vm._v(" "), (_vm.canEditDetails === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditDetails()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-name"
    }
  }, [_vm._v("Industry name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.name),
      expression: "industry.details.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Industry name')
    }],
    attrs: {
      "type": "text",
      "disabled": _vm.canEditDetails === false,
      "data-lpignore": "true",
      "id": "new-industry-name",
      "name": "Industry name"
    },
    domProps: {
      "value": (_vm.industry.details.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Industry name')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Industry name')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-parent"
    }
  }, [_vm._v("Parent industry")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked",
    class: [{
      'has-error': _vm.errors.has('Parent industry')
    }],
    attrs: {
      "searchable": true,
      "disabled": _vm.canEditDetails === false,
      "options": _vm.preparedIndustries,
      "data-vv-name": "Parent industry",
      "data-lpignore": "true",
      "id": "new-industry-parent"
    },
    model: {
      value: (_vm.industry.details.parent),
      callback: function($$v) {
        _vm.$set(_vm.industry.details, "parent", $$v)
      },
      expression: "industry.details.parent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-alias"
    }
  }, [_vm._v("Industry alias")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.slug),
      expression: "industry.details.slug"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled is-disabled",
    attrs: {
      "type": "text",
      "data-lpignore": "true",
      "id": "new-industry-alias",
      "name": "Industry alias",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.industry.details.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "slug", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditDetails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditDetails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryDetails()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryBenchmark",
    staticClass: "content-section content-section__bordered border-1-20 profile-section"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditBenchmark === false) ? [_vm._v("Benchmark")] : [_vm._v("Edit benchmark")]], 2), _vm._v(" "), (_vm.canEditBenchmark === false) ? _c('a', {
    staticClass: "edit-details border-1-40 color-2-100",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditBenchmark()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('table', {
    staticClass: "benchmark-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkPoliciesAndProcedures),
      expression: "industry.benchmarkPoliciesAndProcedures"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Policies and procedures benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkPoliciesAndProcedures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkPoliciesAndProcedures", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkFindingTalent),
      expression: "industry.benchmarkFindingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Finding talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkFindingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkFindingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkAccessingTalent),
      expression: "industry.benchmarkAccessingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Accessing talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkAccessingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkAccessingTalent", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    class: [{
      'is-disabled': _vm.canEditBenchmark === false
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.benchmarkRetainingTalent),
      expression: "industry.benchmarkRetainingTalent"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    attrs: {
      "title": "Retaining talent benchmark",
      "type": "number",
      "min": "0",
      "max": "100",
      "disabled": _vm.canEditBenchmark === false,
      "data-lpignore": "true"
    },
    domProps: {
      "value": (_vm.industry.benchmarkRetainingTalent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry, "benchmarkRetainingTalent", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditBenchmark) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditBenchmark()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryBenchmark()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryChapters",
    staticClass: "content-section content-section__bordered border-1-20 profile-section"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditChapters === false) ? [_vm._v("Task categories")] : [_vm._v("Edit task categories")]], 2), _vm._v(" "), (_vm.canEditChapters === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditChapters()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-pp"
    }
  }, [_vm._v("Policies and procedures")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-pp",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterPoliciesAndProcedures),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterPoliciesAndProcedures", $$v)
      },
      expression: "industry.chapterPoliciesAndProcedures"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-ft"
    }
  }, [_vm._v("Finding talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-ft",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterFindingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterFindingTalent", $$v)
      },
      expression: "industry.chapterFindingTalent"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-at"
    }
  }, [_vm._v("Assessing talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-at",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterAccessingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterAccessingTalent", $$v)
      },
      expression: "industry.chapterAccessingTalent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "new-industry-chapter-rt"
    }
  }, [_vm._v("Retaining talent")]), _vm._v(" "), _c('v-select', {
    staticClass: "form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked form-control__select background-1-10  border-1-10 background-2-10-locked border-2-10-locked-multiple",
    attrs: {
      "id": "new-industry-chapter-rt",
      "debounce": 250,
      "on-search": _vm.getOptionsThingsToConsider,
      "options": _vm.thingsToConsiderOptions,
      "multiple": false,
      "disabled": _vm.canEditChapters === false,
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.industry.chapterRetainingTalent),
      callback: function($$v) {
        _vm.$set(_vm.industry, "chapterRetainingTalent", $$v)
      },
      expression: "industry.chapterRetainingTalent"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditChapters) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditChapters()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryChapters()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industrySponsors",
    staticClass: "content-section content-section__bordered border-1-20",
    class: [{
      'content-section__dark': _vm.canEditSponsors === false
    }]
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditSponsors === false) ? [_vm._v("Sponsors")] : [_vm._v("Edit sponsors")]], 2), _vm._v(" "), (_vm.canEditSponsors === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditSponsors()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.canEditSponsors === true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: ({
        onUpdate: _vm.onUpdate
      }),
      expression: "{ onUpdate: onUpdate }"
    }],
    staticClass: "sponsor-list",
    attrs: {
      "options": _vm.industry.sponsors
    }
  }, _vm._l((_vm.industry.sponsors), function(row, index) {
    return _c('div', {
      staticClass: "sponsor-item"
    }, [_c('div', {
      staticClass: "sponsor-item-handle"
    }), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-logo",
      attrs: {
        "id": 'uploadLogo-' + index
      }
    }, [(row.isLogoFileUploaded === true && row.logo !== '') ? _c('div', {
      staticClass: "sponsor-item-logo__image",
      style: ({
        backgroundImage: _vm.getImage(row.logo)
      })
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.sort = index + 1),
        expression: "row.sort = index + 1"
      }],
      staticClass: "hidden",
      staticStyle: {
        "display": "none"
      },
      domProps: {
        "value": (row.sort = index + 1)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "sort = index + 1", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.isLogoFileUploaded === false),
        expression: "row.isLogoFileUploaded === false"
      }],
      staticClass: "form-label color-2-63 form-label__logo-upload",
      class: [{
        'disabled': _vm.canEditSponsors === false
      }],
      attrs: {
        "for": 'uploadInput-' + index
      }
    }, [_vm._v("\n                    +Upload logo\n                    "), (row.isLogoFileUploaded === false) ? _c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate.reject",
        value: (_vm.veeValidateFileUploadRules),
        expression: "veeValidateFileUploadRules",
        modifiers: {
          "reject": true
        }
      }],
      staticClass: "form-control form-control--file",
      attrs: {
        "type": "file",
        "disabled": _vm.canEditSponsors === false,
        "id": 'uploadInput-' + index,
        "name": "Thumbnail",
        "data-vv-as": "\"Thumbnail\"",
        "value.sync": "row.logo",
        "placeholder": "+Upload logo"
      },
      on: {
        "change": function($event) {
          return _vm.onThumbnailFileChange($event, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (row.isLogoFileUploaded === true) ? _c('div', {
      staticClass: "sponsor-item-logo__remove",
      on: {
        "click": function($event) {
          return _vm.removeLogo(index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-alt"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.alt),
        expression: "row.alt"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Image alt",
        "type": "text",
        "disabled": _vm.canEditSponsors === false,
        "placeholder": "Alt",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.alt)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "alt", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-url"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.url),
        expression: "row.url"
      }],
      staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
      attrs: {
        "title": "Image url",
        "type": "text",
        "disabled": _vm.canEditSponsors === false,
        "placeholder": "Url",
        "data-lpignore": "true"
      },
      domProps: {
        "value": (row.url)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "url", $event.target.value)
        }, function($event) {
          return _vm.addNewRow(index)
        }]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sponsor-item-remove",
      on: {
        "click": function($event) {
          return _vm.removeElement(index)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.canEditSponsors === false) ? _c('div', {
    staticClass: "sponsors-list__edit"
  }, _vm._l((_vm.industry.sponsors), function(row, index) {
    return (row.logo) ? _c('div', {
      staticClass: "sponsor-item"
    }, [_c('div', {
      staticClass: "sponsor-item-logo",
      attrs: {
        "id": 'uploadLogo-' + index
      }
    }, [_c('img', {
      staticClass: "sponsor-item-logo__image",
      attrs: {
        "src": _vm.getImageFullPath(row.logo)
      }
    })])]) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditSponsors) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditSponsors()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustrySponsors()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 details-2",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryDetails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryDetails')
      }
    }
  }, [_vm._v("Industry details ")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryBenchmark'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryBenchmark')
      }
    }
  }, [_vm._v("Benchmark")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 benchmark",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryChapters'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryChapters')
      }
    }
  }, [_vm._v("Task categories")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 sponsors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industrySponsors'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industrySponsors')
      }
    }
  }, [_vm._v("Sponsors")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Policies and procedures")]), _vm._v(" "), _c('th', [_vm._v("Finding talent")]), _vm._v(" "), _c('th', [_vm._v("Assessing talent")]), _vm._v(" "), _c('th', [_vm._v("Retaining talent")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-967b0150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EditIndustry.vue
// module id = 1045
// module chunks = 0